<div class="biometric-enable-prompt">
  <ion-icon name="finger-print" class="biometric-enable-prompt__icon"></ion-icon>

  <h2 class="biometric-enable-prompt__title">{{ 'biometric.enableTitle' | translate }}</h2>

  <p class="biometric-enable-prompt__description">
    {{ 'biometric.enableDescription' | translate }}
  </p>

  <div class="biometric-enable-prompt__actions">
    <ion-button expand="block" (click)="onEnable()">
      {{ 'biometric.enableButton' | translate }}
    </ion-button>
    <ion-button expand="block" fill="clear" (click)="onNotNow()">
      {{ 'biometric.notNowButton' | translate }}
    </ion-button>
  </div>
</div>
